import { useState, useCallback, useEffect } from 'react';

const useFetchData = (fetchFn) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState();

  const doFetch = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fetchFn();
      setLoading(false);
      setData(result);
      setError(false);
    } catch (err) {
      setError(err);
    }
  }, [setLoading, fetchFn, setData, setError]);

  useEffect(() => {
    doFetch();
  }, []);

  return { data, loading, error, refetch: doFetch };
};

export default useFetchData;
